import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
// components
import { ActivityCard } from './index';

const useStyles = makeStyles(theme=> ({
    mainDiv:props=> ({
        width:'calc(100% - 20px)',
        justifyContent:'space-between',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'40px 10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038',
        [theme.breakpoints.between('xs','md')]: {
            boxShadow:'none',
            width:'100%',
            backgroundColor: props.backgroundColor ? props.backgroundColor : 'transparent',
            padding:'10px 0px'
        }
    }),

    mainDiv2:{
        width:'calc(100% - 40px)',
        display:'flex',
        flexDirection:'row',
        flexWrap:'wrap',
        alignItems:'stretch',
        justifyContent:'space-between',
        padding:'0px 20px',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%',
            padding:'0px',
        }
    },
}));

// Product list template
function Product(props) {
    const { products,fontDarkColor, reference, backgroundColor } = props;
    const classes = useStyles({backgroundColor});

    return(
        <div className={classes.mainDiv} ref={reference}>
            <div className={classes.mainDiv2}>
            {React.Children.toArray(products.map(v=> {
                return(
                    <ActivityCard 
                        fontDarkColor={fontDarkColor} // theme color
                        cover={v.cover}
                        name={v.name}
                        rating={v.rating}
                        ageFrom={v.ageFrom}
                        ageTo={v.ageTo}
                        serviceId={v.id}
                        online={v.online}
                        gender={v.serviceGenders && v['serviceGenders'].length > 1 ? v['serviceGenders'].join(" & ") : 
                        v.serviceGenders && v['serviceGenders'].length === 1 ? v['serviceGenders'].join("") : '---'}
                    />
                )
            }))}
            </div>
        </div>
    )
}

export default Product;